module.exports = __webpack_public_path__ + "static/media/startup.3aa345cc.png";